import { AddIcon } from "@chakra-ui/icons"
import { IconButton } from "@chakra-ui/react"
import { FunctionComponent, MouseEventHandler } from "react"
import { useTranslation } from "react-i18next"

type AddButtonProps = {
  ariaLabel?: string,
  onClick?: MouseEventHandler,
}
export const AddButton: FunctionComponent<AddButtonProps> = ({ ariaLabel, onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        aria-label={ariaLabel ?? t('components.addButton.defaultAriaLabel')}
        variant={'outlineRound'}
        colorScheme={'gray'}
        size={'sm'}
        icon={<AddIcon color="gray.400" />}
        onClick={onClick}
      />
    </>
  )
}